import styles from './MaskedElement.module.css';

export const MaskedElement = ({ variant }: { variant?: 'bottomLeft' | 'bottomRight' | 'topRight' }) => {
  if (!variant) {
    return null;
  }

  const variantClass =
    variant === 'bottomRight'
      ? styles.variantBottomRight
      : variant === 'bottomLeft'
        ? styles.variantBottomLeft
        : styles.variantTopRight;

  return <div className={`${styles.base} ${variantClass}`} />;
};
